import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Typography, Button, TextField, Table, TableBody, TableCell,
    TableHead, TableRow, TableContainer, Paper, Pagination, Stack
} from '@mui/material';

import { useAuth } from '../context/AuthContext';
import { useAppContext } from '../context/AppContext';

const Applications = () => {

    const { token } = useAuth();
    const { getApplications, applications } = useAppContext();

    const navigate = useNavigate();
    const [selectedUser, setSelectedUser] = useState(null);
    const [name, setName] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 5;

    useEffect(() => {
        getApplications();
    }, []);

    const handleEdit = (user) => {
        // Navigate to the user edit page
        navigate(`/Applications/${user.id}/update`);
    };

    const handleCreate = () => {
        navigate('/applications/create');
    };

    const paginated = applications.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    console.log('Applications:', applications);

    return (
        <>
            <Typography variant="h5">Applications</Typography>
            <Stack direction="row" spacing={2} alignItems="center" sx={{ my: 2 }}>
                <TextField label="Name" value={name} onChange={e => setName(e.target.value)} />
                <Button variant="contained" onClick={handleCreate}>
                    Add New
                </Button>
            </Stack>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            {/* <TableCell>ID</TableCell> */}
                            <TableCell>Name</TableCell>
                            <TableCell>Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {paginated.map(user => (
                            <TableRow key={user.id}>
                                {/* <TableCell>{user.id}</TableCell> */}
                                <TableCell>{user.name}</TableCell>
                                <TableCell>
                                    <Button variant="outlined" onClick={() => handleEdit(user)}>Modify</Button>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <Pagination
                count={2}
                page={currentPage}
                onChange={(e, page) => setCurrentPage(page)}
                sx={{
                    mt: 2, display: 'flex', justifyContent: 'center',
                    '& .MuiPaginationItem-root': {
                        color: 'white',
                        backgroundColor: 'secondary.main',
                        '&.Mui-selected': {
                            backgroundColor: 'secondary.dark',
                        },
                        '&:hover': {
                            backgroundColor: 'secondary.light',
                        },
                    },
                }}
            />
        </>
    );
};

export default Applications;
